import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "content pt-4 pb-10" }
const _hoisted_3 = { class: "content-wrap relative py-0 w-auto my-0 mx-auto px-4 lg:px-0 lg:w-950px text-left" }
const _hoisted_4 = { class: "overflow-visible" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, null, -1)
const _hoisted_6 = { class: "py-0 float-none w-auto overflow-visible relative block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "results-number tracking-wide border-b border-gray-highlights mb-3 pb-1 uppercase" }, " Search results... ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("section", { class: "filters" }, null, -1)
const _hoisted_10 = { class: "search-results-list -mt-1 list-none" }
const _hoisted_11 = {
  key: 1,
  class: "min-v-screen min-h-screen flex items-center justify-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Result = _resolveComponent("Result")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    (_ctx.anime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("section", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anime, (anime) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: anime.node.id,
                        class: "overflow-hidden py-4 border-b border-gray-resultBorder mb-3 pb-1"
                      }, [
                        _createVNode(_component_Result, { anime: anime }, null, 8, ["anime"])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
  ], 64))
}